import { MenuData } from './Menu.data';

export default (entity_name: string) => {
  return MenuData[entity_name];
};
